import { customer } from "@api/filters/customer/path";
import { employeeCost } from "@api/filters/employeeCost/path";
import { measurementUnit } from "@api/filters/measurementUnit/path";
import { paidInstallment } from "@api/filters/paidInstallment/path";
import { productCategory } from "@api/filters/productCategory/path";
import { productPlan } from "@api/filters/productPlan/path";
import { purchaseInvoices } from "@api/filters/purchaseInvoices/path";
import { salesInvoices } from "@api/filters/salesInvoices/path";
import { store } from "@api/filters/store/path";
import { storeCost } from "@api/filters/storeCost/path";
import { subscription } from "@api/filters/subscription/path";
import { supplier } from "@api/filters/supplier/path";
import { unpaidInstallment } from "@api/filters/unpaidInstallment/path";
import { user } from "@api/filters/user/path";
import { warehouse } from "@api/filters/warehouse/path";

export const filters = {
  productPlan,
  store,
  unpaidInstallment,
  paidInstallment,
  subscription,
  warehouse,
  productCategory,
  measurementUnit,
  user,
  customer,
  supplier,
  storeCost,
  employeeCost,
  purchaseInvoices,
  salesInvoices,
};
